import React from "react"

import AnnouncementBar from "../components/cms/AnnouncementBar"
import ContentWithTitle from "../components/cms/ContentWithTitle"
import DoubleImage from "../components/cms/DoubleImage"
import FullImage from "../components/cms/FullImage"
import ImageLeft from "../components/cms/ImageLeft"
import ImageRight from "../components/cms/ImageRight"
import MediumImage from "../components/cms/MediumImage"
import Minimum20 from "../components/cms/Minimum20"
import NaturalOrganic from "../components/cms/NaturalOrganic"
import NewestCollections from "../components/cms/NewestCollections"
import Reviews from "../components/cms/Reviews"
import SofaTableChair from "../components/cms/SofaTableChair"
import SummerCollections from "../components/cms/SummerCollections"
import WinterCollections from "../components/cms/WinterCollections"

const RenderBlocks = (section) => {
  switch (section.type) {
    case "TitleContent":
      return <ContentWithTitle section={section} />
    case "TitleContentImageRight":
      return <ImageRight section={section} />
    case "ImageLeftTitleContent":
      return <ImageLeft section={section} />
    case "TwoImage":
      return <DoubleImage section={section} />
    case "FullImage":
      return <FullImage section={section} />
    case "MediumImage":
      return <MediumImage section={section} />
    case "TitleContentButtonImageRight":
      return <NewestCollections section={section} />
    case "SubTitleTitleContentButtonImageRight":
      return <NaturalOrganic section={section} />
    case "TitleContentThreeProductsButton":
      return <SummerCollections section={section} />
    case "CollectionBanner":
      return <WinterCollections section={section} />
    case "Banner":
      return <Minimum20 section={section} />
    case "Gallery":
      return <SofaTableChair section={section} />
    case "AnnouncementBar":
      return <AnnouncementBar section={section} />
    case "Reviews":
      return <Reviews section={section} />
  }
}

export default RenderBlocks
